<template>
  <v-app :dark="isDark" class="ncoc-app">
    <div class="app-backdrop">
      <div class="app-glow glow-one"></div>
      <div class="app-glow glow-two"></div>
      <div class="app-grid"></div>
    </div>
    <sm-tool-bar></sm-tool-bar>
    <sm-navigation-bar></sm-navigation-bar>
    <v-main class="app-main">
      <router-view :key="$route.fullPath"></router-view>
    </v-main>

    <sm-common-dialog v-if="dialog"></sm-common-dialog>
    <sm-action-dialog v-if="actionDialog"></sm-action-dialog>
    <sm-alert v-if="error"></sm-alert>
    <sm-progress v-if="progress"></sm-progress>
    <AppDialogQuickEmployee v-if="isQuickSelected" :key="assetProcessed"/>
  </v-app>
</template>

<script>
const BaseAlert = () => import( '@/components/AppAlert');
const Progress = () => import( '@/components/AppProgress');
const Dialog = () => import('@/components/AppDialog.vue');
const ActionDialog = () => import('@/components/AppActionDialog');
const TheFooter = () => import('@/components/TheFooter');
const TheToolBar = () => import('@/components/TheToolbar');
const TheNavigationBar = () => import('@/components/TheNavigationBar');

export default {
  head: {
    title: 'Домашнаяя страница'
  },
  components: {
    'sm-alert': BaseAlert,
    'sm-progress': Progress,
    'sm-common-dialog': Dialog,
    'sm-the-footer': TheFooter,
    'sm-tool-bar': TheToolBar,
    'sm-navigation-bar': TheNavigationBar,
    'sm-action-dialog': ActionDialog,
    'AppDialogQuickEmployee': () => import('@/components/AppDialogQuickEmployee')
  },

  computed: {
    dialog() {
      return this.$store.getters.getDialog && this.$store.getters.isPerimitted
    },
    isDark() {
      return this.$store.getters.getIsDark
    },
    actionDialog() {
      return this.$store.getters.getActionDialog && this.$store.getters.isPerimitted
    },
    progress() {
      return !!this.$store.getters.getProgress && this.$store.getters.isPerimitted
    },
    error() {
      let errList = this.$store.getters.getErrorText||[];
      return errList.length>0 && this.$store.getters.isPerimitted
    },
    isQuickSelected() {
      return this.$store.getters.quickSelected && this.$store.getters.isPerimitted
    },
    assetProcessed() {
      return this.$store.getters.getPageKey
    }
  }
}
</script>

<style>
.ncoc-app {
  position: relative;
  min-height: 100vh;
  background:
    radial-gradient(circle at top left, rgba(44, 123, 229, 0.18), transparent 28%),
    radial-gradient(circle at right center, rgba(15, 118, 110, 0.16), transparent 24%),
    linear-gradient(180deg, #f5f9ff 0%, #eef3f8 48%, #e9eff6 100%);
  color: #10233b;
  overflow: hidden;
}

.ncoc-app.theme--dark {
  background:
    radial-gradient(circle at top left, rgba(67, 97, 238, 0.22), transparent 30%),
    radial-gradient(circle at right center, rgba(16, 185, 129, 0.16), transparent 24%),
    linear-gradient(180deg, #09111d 0%, #0c1727 55%, #0e1a2d 100%);
}

.app-backdrop {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.app-glow {
  position: absolute;
  border-radius: 999px;
  filter: blur(80px);
  opacity: 0.9;
}

.glow-one {
  top: -140px;
  left: -40px;
  width: 340px;
  height: 340px;
  background: rgba(56, 189, 248, 0.28);
}

.glow-two {
  right: -80px;
  bottom: 10%;
  width: 360px;
  height: 360px;
  background: rgba(14, 165, 164, 0.18);
}

.app-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(148, 163, 184, 0.08) 1px, transparent 1px),
    linear-gradient(90deg, rgba(148, 163, 184, 0.08) 1px, transparent 1px);
  background-size: 36px 36px;
  mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.2), transparent 85%);
}

.app-main {
  position: relative;
  z-index: 1;
}
</style>
